import { on } from 'delegated-events'

const SELECTORS = Selectors({
  element: 'element-serviceoverview',
  keyContactItem: 'overview-contact-item'
})

const $element = document.querySelectorAll(SELECTORS.asClass('element'))

const fn = {
  init: () => {
    const keyContactToggle = '.overview-contact-items--multiple .overview-contact__name'

    on('click', keyContactToggle, fn.handleKeyContactToggle)
    on('keydown', keyContactToggle, fn.handleKeyContactToggle)
  },

  handleKeyContactToggle: (e) => {
    if (e.target.closest(SELECTORS.asClass('keyContactItem'))) {
      const expanded = e.target.getAttribute('aria-expanded') === 'true'

      if (expanded) {
        fn.closeKeyContact(e.target)
      } else {
        fn.openKeyContact(e.target)
      }
    }
  },

  openKeyContact: ($el) => {
    const $item = $el.closest(SELECTORS.asClass('keyContactItem'))

    $el.setAttribute('aria-expanded', 'true')
    $item.classList.add('is-active')
    $($el).siblings('.overview-contact__body').slideToggle('fast')

    const $other = $(`${SELECTORS.asClass('keyContactItem')}.is-active`).not($item).find('.overview-contact__name')

    if ($other.length) {
      fn.closeKeyContact($other[0])
    }
  },

  closeKeyContact: ($el) => {
    const $item = $el.closest(SELECTORS.asClass('keyContactItem'))

    $el.setAttribute('aria-expanded', 'false')
    $item.classList.remove('is-active')
    $($el).siblings('.overview-contact__body').slideToggle('fast')
  },
}

export default {
  can: () => $element.length,
  run: fn.init
}
